import { render, staticRenderFns } from "./certificateSettings.vue?vue&type=template&id=4e12b600&scoped=true&"
import script from "./certificateSettings.vue?vue&type=script&lang=js&"
export * from "./certificateSettings.vue?vue&type=script&lang=js&"
import style0 from "./certificateSettings.vue?vue&type=style&index=0&id=4e12b600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e12b600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VSheet})
